import { Box, Typography } from "@mui/material";
import { ComingSoonIcon } from "../../assets/icons/MUI/NetworkIcons";
import { colors } from "../../theme/palette";
import { useTranslation } from "react-i18next";

const MembersComingSoon = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: "32px",
        gridColumn: "1 / span 3",
        margin: "190px auto 0",
      }}
    >
      <ComingSoonIcon />
      <Typography
        variant="h5Bold"
        sx={{
          color: colors.Green100,
          textAlign: "center",
          fontWeight: "700",
        }}
      >
        {t("components.networkController.comingSoon")}
      </Typography>
      {/* <Typography
        variant="body14Regular"
        sx={{
          color: colors.Dark600,
          textAlign: "center",
          display: "block",
        }}
      >
        {t("components.networkController.oopsNoTalents")}
        <br />
        {t("components.networkController.pleaseRefine")}
      </Typography> */}
    </Box>
  );
};

export default MembersComingSoon;
